import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';

// ML
import PolicyChangePage from './pages/PolicyChanges/PolicyChangePage';
import AdditionalChangesPage from './pages/AdditionalChanges/AdditionalChangesPage';
import PolicyChangeSummaryPage from './pages/PolicyChangeSummary/PolicyChangeSummaryPage';
import EndorsementAgentSignatureOptionsPage from './pages/AgentSignatureOptions/AgentSignatureOptionsPage';
import InterestedPartiesPage from '../ml-capability-policychange-common-react/pages/InterestedParties/InterestedPartiesPage';
import MLCoveragesPage from './pages/MLCoverages/MLCoveragesPage';
import MLCECoveragesPage from './pages/MLCECoverages/MLCECoveragesPage';

import ESignaturePage from './pages/PolicyChangeESignature/PolicyChangeESignaturePage'
import ConfirmationPage from './pages/Confirmation/ConfirmationPage';
import HOPAPaymentPage from './pages/Payments/HOPAPaymentPage/PaymentPage';
import CPBOPPaymentPage from './pages/Payments/CPBOPPaymentPage/PaymentPage';
import PolicyChangeUtil from './utils/PolicyChangeUtil';
import ProfileDetailsPagePolChange from '../ml-capability-policychange-common-react/pages/ProfileDetails/ProfileDetailsPagePolChange';


setComponentMapOverrides(
    {
        HOPAPaymentPage: { component: 'HOPAPaymentPage' },
        CPBOPPaymentPage: { component: 'CPBOPPaymentPage' },
        ConfirmationPage: { component: 'ConfirmationPage' },

        PolicyChangePage: { component: 'PolicyChangePage' },
        ProfileDetailsPagePolChange: { component: 'ProfileDetailsPagePolChange' },
        AdditionalChangesPage: { component: 'AdditionalChangesPage' },
        PolicyChangeSummaryPage: { component: 'PolicyChangeSummaryPage' },
        EndorsementAgentSignatureOptionsPage: { component: 'EndorsementAgentSignatureOptionsPage'},
        InterestedPartiesPage: { component: 'InterestedPartiesPage'},
        MLCoveragesPage: { component: 'MLCoveragesPage' },
        ESignaturePage:{component:'ESignaturePage'},
        MLCECoveragesPage: { component: 'MLCECoveragesPage' }
    },
    {
        HOPAPaymentPage,
        CPBOPPaymentPage,
        ConfirmationPage,
        PolicyChangePage,
        AdditionalChangesPage,
        PolicyChangeSummaryPage,
        InterestedPartiesPage,
        EndorsementAgentSignatureOptionsPage,
        ProfileDetailsPagePolChange,
        MLCoveragesPage,
        ESignaturePage,
        MLCECoveragesPage
    }
);

export { PolicyChangeUtil };
export { default as messages } from './PolicyChangeCommon.messages';
export { default as PolicyChange } from './models/PolicyChange';
export { default as ConfirmationQuoteDetailsPage } from './pages/ConfirmationQuoteDetails/ConfirmationQuoteDetailsPage';
export { default as CPBOPPaymentPage } from './pages/Payments/CPBOPPaymentPage/PaymentPage';
export { default as PolicyChangePage } from './pages/PolicyChanges/PolicyChangePage';
export { default as AdditionalChangesPage } from './pages/AdditionalChanges/AdditionalChangesPage';
export { default as InterestedPartiesPage } from '../ml-capability-policychange-common-react/pages/InterestedParties/InterestedPartiesPage';
export { default as CustomHeaderComponent } from './components/CustomHeaderComponent/CustomHeaderComponent';
export { default as SideMenuComponent} from './components/SideMenuComponent/SideMenuComponent';
export { default as AvailableDocumentsComponent} from './components/AvailableDocumentsComponent/AvailableDocumentsComponent';
export { default as RequiredSignaturesComponent} from './components/RequiredSignaturesComponent/RequiredSignaturesComponent';
export { default as VerbalAuthorizationComponent} from './components/VerbalAuthorizationComponent/VerbalAuthorizationComponent';
export { default as DocumentsTableComponent } from './components/DocumentsTableComponent/DocumentsTableComponent';
export { default as ESignaturePage} from './pages/PolicyChangeESignature/PolicyChangeESignaturePage';
export { default as DocumentUploadComponent } from './components/DocumentUploadComponent/DocumentUploadComponent'
